<template>
  <div class="app">
    <component :is="layout" :key="$route.fullPath">
      <router-view></router-view>
    </component>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    layout() {
      return this.$route.meta.layout || 'default'
    }
  }
}
</script>
<style lang="scss">
body,
html {
  background-color: #f3f3f3;
}
</style>
